import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImpactRatingModel } from 'src/app/core/models/impact-assessment/impact-outcome';
import { ImpactOutcomeComponent } from '../impact-outcome/impact-outcome.component';

@Component({
  selector: 'app-impact-rating-dialog',
  templateUrl: './impact-rating-dialog.component.html',
  styleUrls: ['./impact-rating-dialog.component.scss'],
})
export class ImpactRatingDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public ratingInfo: ImpactRatingModel) { }
 // @ViewChild('impactOutcome') impactOutcome:ImpactOutcomeComponent;
  @ViewChild(ImpactOutcomeComponent)
  impactOutcome!: ImpactOutcomeComponent;
  ngOnInit(): void {
  }
  saveImpactAssessmentList(){
    this.impactOutcome.saveImpactAssessmentList();
  }
  resetImpactAssesmnent(){
    this.impactOutcome.resetImpactAssesmnent();
  }
}
